import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Grid,
  Typography,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Divider,
  Dialog,
  Switch,
  DialogTitle,
  IconButton,
  DialogContent,
  CircularProgress,
} from "@mui/material";
import Heading from "../../AdminComponents/Common/Heading";
import CustomButton from "../../Components/Common/CustomButton";
import TextInput from "../../Components/Common/TextInput";
import { theme } from "../../Assets/Theme/theme";
import Dropdown from "../../AdminComponents/Common/Dropdown";
import MapComponent from "../../Components/Common/MapComponent";
import MultiInputs from "../../AdminComponents/Common/MultiInputs";
import CustomCheckboxLabel from "../../AdminComponents/Common/CustomCheckboxLabel";
import TimeSlotComponent from "../../AdminComponents/Experience/TimeSlotComponent";
import UploadImagesComponent from "../../AdminComponents/Experience/UploadImagesComponent";
import UploadVideosComponent from "../../AdminComponents/Experience/UploadVideosComponent";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { BASE_URL } from "../../Assets/Constants";
import { currencyOptions } from "../../Services/dymmyData";
import { toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import "react-calendar/dist/Calendar.css";
import Calendar from "react-calendar/dist/cjs/Calendar.js";
import ReactQuill from "react-quill";

const options = [
  { value: "1", label: "Option 1" },
  { value: "2", label: "Option 2" },
  { value: "3", label: "Option 3" },
];
const options2 = [
  { value: "option1", label: "Option 1" },
  { value: "option2", label: "Option 2" },
  { value: "option3", label: "Option 3" },
];
const options3 = [
  { value: "Standard", label: "Standard" },
  { value: "Premium", label: "Premium" },
  { value: "Skip the Line", label: "Skip the Line" },
];

const ExperienceCreation = ({ ...props }) => {
  const navigate = useNavigate();
  const { type } = useParams();
  const location = useLocation();
  const experienceDetails = location.state;
  const [loading, setLoading] = useState(false);
  const [selectedPosition, setSelectedPosition] = useState([30.3753, 69.3451]);

  useEffect(() => {
    const fetchCoordinates = async () => {
      if (!experienceDetails?.location) {
        console.warn("Location is undefined or null, using default location.");
        setSelectedPosition([37.0902, -95.7129]);
        return;
      }

      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(
            experienceDetails.location
          )}&format=json&limit=1`
        );
        const result = await response.json();

        if (Array.isArray(result) && result.length > 0 && result[0] !== null) {
          const lat = result[0]?.lat ? parseFloat(result[0].lat) : null;
          const lon = result[0]?.lon ? parseFloat(result[0].lon) : null;

          if (lat !== null && lon !== null) {
            setSelectedPosition([lat, lon]);
          } else {
            console.warn("No valid coordinates found, using default location.");
            setSelectedPosition([37.0902, -95.7129]);
          }
        } else {
          console.warn("Invalid API response or empty array, using default location.");
          setSelectedPosition([37.0902, -95.7129]);
        }
      } catch (error) {
        console.error("Error fetching coordinates:", error);
        setSelectedPosition([37.0902, -95.7129]);
      }
    };

    fetchCoordinates();
  }, [experienceDetails?.location]);


  const [isRowAligned, setIsRowAligned] = useState(experienceDetails?.additionalInfo ? true : false);
  const [isTimeSlotAvailable, setIsTimeSlotAvailable] = useState(experienceDetails?.isTimeslot || false);

  const [options3, setOptions3] = useState([]);
  const loginData = JSON.parse(localStorage.getItem("adminData"));
  const token = loginData?.token;

  const handleToggleAlignment = async () => {
    setIsRowAligned((prev) => {
      const newValue = !prev;

      setFormData((prevData) => ({
        ...prevData,
        additionalInfo: newValue
          ? prevData.additionalInfo
          : { DOB: "", Height: "", Weight: "" },
      }));

      return newValue;
    });
  };


  const handleToggleTimeSlot = () => {
    setIsTimeSlotAvailable((prev) => {
      const newState = !prev;

      if (!newState) {
        setFormData((prevData) => ({
          ...prevData,
          priceCategories: [],
          ticketTypes: [],
        }));
      }

      return newState;
    });
  };

  const [locationSuggestions, setLocationSuggestions] = useState([]);

  const [formData, setFormData] = useState({
    name: experienceDetails?.name || "",
    type: experienceDetails?.type || "",
    duration: experienceDetails?.duration || "",
    country_city: experienceDetails?.country_city || "",
    currency: experienceDetails?.currency || "",
    location: experienceDetails?.location || "",
    address: "",
    timezone: experienceDetails?.timezone || "",
    description: experienceDetails?.description || "",
    highlights: experienceDetails?.highlights || "",
    termAndCondition: experienceDetails?.termAndCondition || "",
    inclusions: experienceDetails?.inclusions || [],
    exclusions: experienceDetails?.exclusions || [],
    knowBeforeYouGo: experienceDetails?.knowBeforeYouGo || [],
    operatingHours: {
      from: experienceDetails?.operatingHours?.from || "",
      to: experienceDetails?.operatingHours?.to || "",
    },
    ticketTypes: experienceDetails?.ticketTypes?._id ? [experienceDetails.ticketTypes._id] : "",
    priceCategories: Array.isArray(experienceDetails?.priceCategories)
      ? experienceDetails?.priceCategories.map((category) => ({
        timeSlot: !isTimeSlotAvailable ? category.timeSlot : "",
        prices: Array.isArray(category.prices)
          ? category.prices.map((price) => ({
            price: price.price || 0,
            salePrice: price.salePrice || 0,
            age: price?.age?._id || price.age || "",
            ageName: price?.age?.name || "",
          }))
          : [],
      }))
      : [],
    isBookingConfirmedManually:
      experienceDetails?.isBookingConfirmedManually || false,
    photos: experienceDetails?.photos || [],
    videos: experienceDetails?.videos || [],
    isTimeslot: isTimeSlotAvailable,
    additionalInfo: isRowAligned
      ? {
        DOB: experienceDetails?.additionalInfo?.DOB || "",
        Height: experienceDetails?.additionalInfo?.Height || null, // Send null instead of empty string
        Weight: experienceDetails?.additionalInfo?.Weight || null, // Send null instead of empty string
      }
      : {},
  });

  const today = new Date();
  const fiveYearsAgo = new Date(
    today.getFullYear() - 5,
    today.getMonth(),
    today.getDate()
  );

  console.log(experienceDetails, "EXPERIENCE DETAILS");


  const [selectedValue, setSelectedValue] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  const [open, setOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(fiveYearsAgo);
  const [calendarView, setCalendarView] = useState("month");

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const parseDate = (dateString) => {
    if (!dateString) return null;
    const [day, month, year] = dateString.split("/").map(Number);
    return new Date(year, month - 1, day);
  };

  useEffect(() => {
    const fetchTicketTypes = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/admin/tickets`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.data.success) {
          const ticketOptions = response.data.ticketTypes.map((ticket) => ({
            label: ticket.name,
            value: ticket._id,
          }));
          setOptions3(ticketOptions);
        }
      } catch (error) {
        console.error("Error fetching ticket types:", error?.response);
      }
    };

    fetchTicketTypes();
  }, []);

  const handleDateChange = (date) => {
    const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);

    const formattedDate = localDate.toISOString().split("T")[0];

    setSelectedDate(formattedDate);
    setFormData((prev) => ({
      ...prev,
      additionalInfo: { ...prev.additionalInfo, DOB: formattedDate },
    }));

    handleClose();
  };

  const handlePriceCategoryChange = (updatedCategories) => {
    setFormData((prev) => ({ ...prev, priceCategories: updatedCategories }));
  };

  const handleChange = (field, value) => {
    if (field === "ticketTypes") {
      setFormData((prev) => ({
        ...prev,
        ticketTypes: Array.isArray(value) ? value : [value],
      }));
    } else if (field.includes("additionalInfo.")) {
      const key = field.split(".")[1];
      const isNumericField = ["Height", "Weight"].includes(key);

      setFormData((prev) => ({
        ...prev,
        additionalInfo: {
          ...prev.additionalInfo,
          [key]: isNumericField ? parseInt(value, 10) || "" : value,
        },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [field]: value }));
    }

    setFieldErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  const formatPayload = (data) => {
    return {
      name: data.name || "",
      type: data.type || "",
      duration: data.duration || "",
      country_city: data.country_city || "",
      currency: data.currency || "",
      location: data.location || "",
      description: data.description || "",
      highlights: data.highlights || "",
      termAndCondition: data.termAndCondition || "",
      inclusions: data.inclusions,
      exclusions: data.exclusions,
      knowBeforeYouGo: data.knowBeforeYouGo,
      operatingHours: {
        from: data.operatingHours?.from || "",
        to: data.operatingHours?.to || "",
      },
      ticketTypes: Array.isArray(data.ticketTypes) ? data.ticketTypes : [],
      priceCategories: Array.isArray(data.priceCategories)
        ? data.priceCategories.map((category) => ({
          timeSlot: !isTimeSlotAvailable ? category.timeSlot : "",
          prices: Array.isArray(category.prices)
            ? category.prices.map((price) => ({
              price: price.price || 0,
              salePrice: price.salePrice || 0,
              age: price?.age?._id || price.age || "",
            }))
            : [],
        }))
        : [],
      isBookingConfirmedManually: data.isBookingConfirmedManually || false,
      isTimeslot: isTimeSlotAvailable,
      photos: formatPhotos(data.photos),
      videos: data.videos || [],
      additionalInfo: isRowAligned
        ? {
          DOB: data.additionalInfo?.DOB || "",
          Height: data.additionalInfo?.Height || null,
          Weight: data.additionalInfo?.Weight || null,
        }
        : {},
      timezone: data.timezone || "",
    };
  };

  const stripHtml = (html) => {
    return html.replace(/<[^>]*>/g, "").trim();
  };

  const formatPhotos = (photos) => {
    return photos.map((photo) =>
      photo.startsWith("data:image/") ? photo : `${photo}`
    );
  };

  const handleSubmit = async () => {
    setLoading(true);
    let errors = {};

    if (isRowAligned) {
      if (!formData.additionalInfo.DOB) {
        errors["additionalInfo.DOB"] = "DOB cannot be empty";
      }
      if (!formData.additionalInfo.Height) {
        errors["additionalInfo.Height"] = "Height cannot be empty";
      }
      if (!formData.additionalInfo.Weight) {
        errors["additionalInfo.Weight"] = "Weight cannot be empty";
      }
    }

    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      setLoading(false);
      return;
    }

    const formattedData = formatPayload({ ...formData, isTimeslot: isTimeSlotAvailable });

    console.log(formattedData, "FORMATTED");


    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const apiUrl =
        type === "add"
          ? `${BASE_URL}/admin/experience/store`
          : `${BASE_URL}/admin/experience/${experienceDetails?._id}/update`;

      const method = type === "add" ? "post" : "put";

      const response = await axios({
        method,
        url: apiUrl,
        data: formattedData,
        ...config,
        maxContentLength: Infinity,
        maxBodyLength: Infinity
      });

      console.log(response, "RESSS");


      if (response?.data?.message) {
        toast.success(response?.data?.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          style: { backgroundColor: 'orange', color: 'white' },
        });
      } else {
        toast.success("Experience Updated Successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          style: { backgroundColor: 'orange', color: 'white' },
        });
      }
      navigate("/admin/experiences");
    } catch (error) {
      console.log(error?.response, "ERRORS");

      if (error?.response?.data?.errors) {
        const mappedErrors = error.response.data.errors.reduce(
          (acc, err) => ({ ...acc, [err.path]: err.msg }),
          {}
        );
        setFieldErrors(mappedErrors);
      } else if (error?.response?.data?.message) {
        toast.error(`${error?.response?.data?.message}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        handleSubmit();
      }
    };

    window.addEventListener("keypress", handleKeyPress);

    return () => {
      window.removeEventListener("keypress", handleKeyPress);
    };
  }, [formData]);

  useEffect(() => {
    if (selectedPosition) {
      setTimeout(() => {
        document.dispatchEvent(new Event("updateMap"));
      }, 500);
    }
  }, [selectedPosition]);

  const generateHourlyTimeSlots = () => {
    const intervals = [];
    for (let hour = 0; hour < 24; hour++) {
      const time = `${hour.toString().padStart(2, "0")}:00`;
      intervals.push({ label: time, value: time });
    }
    return intervals;
  };

  const handleLocationInput = async (input) => {
    setFormData((prev) => ({ ...prev, location: input }));

    if (input.length > 2) {
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(
            input
          )}&format=json&addressdetails=1&limit=5`
        );
        const data = await response.json();
        setLocationSuggestions(data);
      } catch (error) {
        console.error("Error fetching location suggestions:", error);
      }
    } else {
      setLocationSuggestions([]);
    }
  };

  const getTimeZone = async (lat, lng) => {
    try {
      const response = await fetch(
        `http://api.geonames.org/timezoneJSON?lat=${lat}&lng=${lng}&username=demo`
      );
      const data = await response.json();
      return data?.timezoneId || "Unknown";
    } catch (error) {
      console.error("Error fetching time zone:", error);
      return "Unknown";
    }
  };

  const handleSelectLocation = async (selectedLocation) => {
    const { lat, lon, display_name, address } = selectedLocation;

    setFormData((prev) => ({
      ...prev,
      location: display_name,
      country_city: `${address.city || address.town || address.village}, ${address.country}`,
    }));

    setSelectedPosition([parseFloat(lat), parseFloat(lon)]);

    const timeZone = await getTimeZone(lat, lon);
    setFormData((prev) => ({
      ...prev,
      timezone: timeZone?.timeZoneId || "Unknown",
    }));

    setLocationSuggestions([]);
  };


  const timeSlots = generateHourlyTimeSlots();

  return (
    <Box>
      <Heading
        back={true}
        label={type === "add" ? "Add Experience" : "Edit Experience"}
        style={{
          fontSize: "20px",
        }}
      />
      <Box mt={4}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={3}>
            <TextInput
              bgColor={theme.colors.inpGray}
              label={"Name"}
              placeholder={"Enter Experience Name"}
              value={formData.name}
              error={Boolean(fieldErrors.name)}
              onChange={(e) => handleChange("name", e.target.value)}
            />
            {fieldErrors.name && (
              <Typography color="error" variant="caption">
                {fieldErrors.name}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12} md={3}>
            {/* <TextInput
              bgColor={theme.colors.inpGray}
              label={"Type"}
              placeholder={"e.g: Day Tour, Adventure Type, Relaxation Type"}
              value={formData.type}
              error={Boolean(fieldErrors.type)}
              onChange={(e) => handleChange("type", e.target.value)}
            /> */}
            <Dropdown
              label="Type"
              placeholder="Select an option"
              value={formData.type}
              onChange={(e) => handleChange("type", e.target.value)}
              options={[
                { label: "City Tour", value: "City Tour" },
                { label: "Tour", value: "Tour" },
                { label: "Theme Park", value: "Theme Park" },
                { label: "Water Park", value: "Water Park" },
                { label: "Adrenaline", value: "Adrenaline" },
                { label: "Adults Only", value: "Adults Only" },
                { label: "Amusement Park", value: "Amusement Park" },
                { label: "Romantic", value: "Romantic" },
                { label: "Food & Beverage", value: "Food & Beverage" },
              ]}
              inputHeight="22px"
            />
            {fieldErrors.type && (
              <Typography color="error" variant="caption">
                {fieldErrors.type}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12} md={3}>
            <TextInput
              bgColor={theme.colors.inpGray}
              label={"Duration"}
              placeholder={"Enter Duration (e.g., 4)"}
              value={formData.duration || ""}
              error={Boolean(fieldErrors.duration)}
              onChange={(e) => {
                const value = e.target.value;
                const decimalRegex = /^[0-9]*\.?[0-9]*$/;
                if (decimalRegex.test(value)) {
                  handleChange("duration", value);
                }
              }}
            />
            {fieldErrors.duration && (
              <Typography color="error" variant="caption">
                {fieldErrors.duration}
              </Typography>
            )}
          </Grid>

          <Grid item xs={12} md={3}>
            {/* <TextInput
              label="Timing Preference"
              placeholder="Your timezone"
              value={formData?.timezone}
              onChange={(e) => handleChange("timezone", e.target.value)}
              options={options}
              disabled={true}
            /> */}
            <Dropdown
              options={currencyOptions}
              placeholder="Select Currency"
              label={"Choose Currency"}
              value={formData.currency}
              onChange={(e) => handleChange("currency", e.target.value)}
              images
              inputHeight="22px"
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextInput
              bgColor={theme.colors.inpGray}
              label={"Country/City"}
              placeholder={"Enter Country and City"}
              value={formData.country_city}
              disabled={true}
              onChange={(e) => handleChange("country_city", e.target.value)}
            />
            {fieldErrors.country_city && (
              <Typography color="error" variant="caption">
                {fieldErrors.country_city}
              </Typography>
            )}
          </Grid>
          {/* <Grid item xs={12} md={3}>
            <Dropdown
              options={currencyOptions}
              placeholder="Select Currency"
              label={"Choose Currency"}
              value={formData.currency}
              onChange={(e) => handleChange("currency", e.target.value)}
              images
            />
          </Grid> */}
          <Grid item xs={12} md={9}>
            <TextInput
              bgColor={theme.colors.inpGray}
              label={"Location"}
              placeholder={"Enter Experience Location"}
              value={formData.location}
              onChange={(e) => handleLocationInput(e.target.value)}
            />

            {locationSuggestions.length > 0 && (
              <Box
                sx={{
                  backgroundColor: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  width: "100%",
                  maxHeight: "200px",
                  overflowY: "auto",
                }}
              >
                {locationSuggestions.map((loc, index) => (
                  <Typography
                    key={index}
                    onClick={() => handleSelectLocation(loc)}
                    sx={{
                      padding: "10px",
                      cursor: "pointer",
                      "&:hover": { backgroundColor: "#f0f0f0" },
                    }}
                  >
                    {loc.display_name}
                  </Typography>
                ))}
              </Box>
            )}


            {fieldErrors.location && (
              <Typography color="error" variant="caption">
                {fieldErrors.location}
              </Typography>
            )}
          </Grid>

          <Grid item xs={12} md={12}>
            <MapComponent
              selectedPosition={selectedPosition}
              onLocationChange={(locationDetails) => {
                console.log(locationDetails, "LOCATION DETAILS");
                
                setFormData((prev) => ({
                  ...prev,
                  country_city: `${locationDetails.city}, ${locationDetails.country}`,
                  location: locationDetails.formattedAddress,
                  timezone: locationDetails.timeZone,
                }));
              }}
            />
          </Grid>

          <Grid item xs={12}>
            {/* <TextInput
              multiline
              bgColor={theme.colors.inpGray}
              label={"Description"}
              rows={4}
              placeholder={"Enter Experience Description"}
              value={formData.description}
              error={Boolean(fieldErrors.description)}
              onChange={(e) => handleChange("description", e.target.value)}
            /> */}

            <Typography
              variant="body1"
              sx={{
                fontWeight: "700",
                mb: 1,
                color: "#121212",
                fontSize: "20px",
              }}
            >
              Description
            </Typography>

            <ReactQuill
              theme="snow"
              value={formData.description}
              style={{ height: "100px" }}
              onChange={(content) => handleChange("description", content)}
            />

            {fieldErrors.description && (
              <Typography color="error" variant="caption">
                {fieldErrors.description}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: "700",
                mb: 1,
                color: "#121212",
                fontSize: "20px",
                marginTop: 5
              }}
            >
              Highlights
            </Typography>

            <ReactQuill
              theme="snow"
              value={formData.highlights}
              style={{ height: "100px", marginBottom: "40px" }}
              onChange={(content) => handleChange("highlights", content)}
            />
            {fieldErrors.highlights && (
              <Typography color="error" variant="caption">
                {fieldErrors.highlights}
              </Typography>
            )}
          </Grid>
        </Grid>

      </Box>
      <Box
        mt={2}
        display={"flex"}
        flexDirection={"column"}
        gap={2}
        sx={{
          width: { xs: "100%", md: "50%" },
        }}
      >
        <MultiInputs
          label="Inclusions"
          fontSize="20px"
          fontWeight={700}
          value={formData.inclusions}
          onChange={(updatedValue) => handleChange("inclusions", updatedValue)}
        />
        <MultiInputs
          label="Exclusion"
          fontSize="20px"
          fontWeight={700}
          value={formData.exclusions}
          onChange={(value) => handleChange("exclusions", value)}
        />
        <MultiInputs
          label="Know Before You Go"
          fontSize="20px"
          fontWeight={700}
          value={formData.knowBeforeYouGo}
          onChange={(value) => handleChange("knowBeforeYouGo", value)}
        />

        {/* <TextInput
          label="Operating Hours"
          placeholder="Enter Operating Hours (e.g., 9 - 7)"
          bgColor={theme.colors.inpGray}
          value={
            formData.operatingHours.from && formData.operatingHours.to
              ? `${formData.operatingHours.from} - ${formData.operatingHours.to}`
              : formData.operatingHours.inputValue || ""
          }
          onChange={(e) => {
            const value = e.target.value;

            handleChange("operatingHours", { ...formData.operatingHours, inputValue: value });

            if (!value) {
              handleChange("operatingHours", { inputValue: "", from: "", to: "" });
              return;
            }

            if (value.includes(" - ")) {
              const [from, to] = value.split(" - ").map((part) => part.trim());
              handleChange("operatingHours", { inputValue: value, from, to });
            }
          }}
          error={Boolean(
            fieldErrors["operatingHours.from"] || fieldErrors["operatingHours.to"]
          )}
        />

        {fieldErrors["operatingHours.from"] && (
          <Typography color="error" variant="caption">
            {fieldErrors["operatingHours.from"]}
          </Typography>
        )}

        {fieldErrors["operatingHours.to"] && (
          <Typography color="error" variant="caption">
            {fieldErrors["operatingHours.to"]}
          </Typography>
        )} */}
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12}>
            <Typography variant="body1" sx={{ fontWeight: 700, fontSize: "20px" }}>
              Operating Hours
            </Typography>
          </Grid>

          <Grid item xs={12} md={3}>
            <Dropdown
              label="Start Time"
              placeholder="Select"
              value={formData.operatingHours.from || undefined}
              onChange={(e) => {
                const newFromTime = e.target.value;

                let newToTime = formData.operatingHours.to;
                if (newToTime && newToTime < newFromTime) {
                  newToTime = newFromTime;
                }

                handleChange("operatingHours", {
                  ...formData.operatingHours,
                  from: newFromTime,
                  to: newToTime,
                });
              }}
              options={timeSlots}
              fullWidth
              labelHeading
              height={"250px"}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <Dropdown
              label="End Time"
              placeholder="Select"
              value={formData.operatingHours.to || undefined}
              onChange={(e) =>
                handleChange("operatingHours", {
                  ...formData.operatingHours,
                  to: e.target.value,
                })
              }
              options={timeSlots.filter(
                (slot) => !formData.operatingHours.from || slot.value > formData.operatingHours.from
              )}
              fullWidth
              labelHeading
              height={"250px"}
            />
          </Grid>

        </Grid>
        {fieldErrors["operatingHours.from"] && (
          <Typography color="error" variant="caption">
            {fieldErrors["operatingHours.from"]}
          </Typography>
        )}

        {fieldErrors["operatingHours.to"] && (
          <Typography color="error" variant="caption">
            {fieldErrors["operatingHours.to"]}
          </Typography>
        )}

        {/* <Dropdown
          label="Ticket Types"
          placeholder="Select an option"
          value={formData?.ticketTypes}
          onChange={(e) => handleChange("ticketTypes", e.target.value)}
          options={options3}
          height={"250px"}
        /> */}
        {/* <TextInput
          label="Categories"
          placeholder="Enter Category"
          bgColor={theme.colors.inpGray}
        /> */}

        {/* <Dropdown
          label="Additional Information"
          placeholder="Select an option"
          value={formData.additionalInfo}
          onChange={(e) => handleChange("additionalInfo", e.target.value)}
          options={options2}
        />

        {fieldErrors.additionalInfo && (
          <Typography color="error" variant="caption">
            {fieldErrors.additionalInfo}
          </Typography>
        )} */}

        <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
          <Typography sx={{ fontWeight: "700", fontSize: "20px" }}>
            Additional Info
          </Typography>
          <FormControlLabel
            sx={{ margin: 0 }}
            control={
              <Switch
                checked={isRowAligned}
                onChange={handleToggleAlignment}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: theme.colors.orange,
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: theme.colors.orange,
                  },
                }}
              />
            }
            label={null}
          />

        </Box>

        {isRowAligned &&
          <Box
            mt={0}
            display={"flex"}
            flexDirection={"row"}
            gap={2}
            sx={{
              width: { xs: "100%", md: "100%" },
            }}
          >
            {/* DOB Field */}
            <Box>
              <TextInput
                label="DOB"
                placeholder="YYYY-MM-DD"
                disabled={true}
                bgColor={theme.colors.inpGray}
                value={formData.additionalInfo.DOB}
                onClick={handleOpen}
                onChange={(e) => handleChange("additionalInfo.DOB", e.target.value)}
                error={Boolean(fieldErrors["additionalInfo.DOB"])}
                fontSize="16px"
              />
              {fieldErrors["additionalInfo.DOB"] && (
                <Typography color="error" variant="caption">
                  {fieldErrors["additionalInfo.DOB"]}
                </Typography>
              )}
            </Box>

            {/* Height Field */}
            <Box>
              <TextInput
                label="Height"
                placeholder="Height (cm)"
                bgColor={theme.colors.inpGray}
                value={formData.additionalInfo.Height}
                onChange={(e) => handleChange("additionalInfo.Height", e.target.value)}
                error={Boolean(fieldErrors["additionalInfo.Height"])}
                fontSize="16px"
              />
              {fieldErrors["additionalInfo.Height"] && (
                <Typography color="error" variant="caption">
                  {fieldErrors["additionalInfo.Height"]}
                </Typography>
              )}
            </Box>

            {/* Weight Field */}
            <Box>
              <TextInput
                label="Weight"
                placeholder="Weight (kg)"
                bgColor={theme.colors.inpGray}
                value={formData.additionalInfo.Weight}
                onChange={(e) => handleChange("additionalInfo.Weight", e.target.value)}
                error={Boolean(fieldErrors["additionalInfo.Weight"])}
                fontSize="16px"
              />
              {fieldErrors["additionalInfo.Weight"] && (
                <Typography color="error" variant="caption">
                  {fieldErrors["additionalInfo.Weight"]}
                </Typography>
              )}
            </Box>
          </Box>
        }
        {/* {fieldErrors.additionalInfo && (
          <Typography color="error" variant="caption">
            {fieldErrors.additionalInfo}
          </Typography>
        )} */}


        <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
          <Typography sx={{ fontWeight: "700", fontSize: "20px" }}>
            Price Category
          </Typography>
          <FormControlLabel
            sx={{ margin: 0 }}
            control={
              <Switch
                checked={isTimeSlotAvailable}
                onChange={handleToggleTimeSlot}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: theme.colors.orange,
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: theme.colors.orange,
                  },
                }}
              />
            }
            label={null}
          />

        </Box>
      </Box>

      <Box mb={3}>
        <TimeSlotComponent
          priceCategories={formData.priceCategories || []}
          onPriceCategoryChange={handlePriceCategoryChange}
          value={formData?.ticketTypes}
          onChange={(e) => handleChange("ticketTypes", e.target.value)}
          options={options3}
          isTimeSlotAvailable={isTimeSlotAvailable}
        />
      </Box>

      {fieldErrors.priceCategories && (
        <Typography color="error" variant="caption">
          {fieldErrors.priceCategories}
        </Typography>
      )}

      <Grid item xs={12}>

        <TextInput
              label={"Terms and Conditions"}
              placeholder={"Enter Terms and Conditions"}
              value={formData.termAndCondition}
              multiline
              rows={4}
              onChange={(e) => handleChange("termAndCondition", e.target.value)}
            />
        {fieldErrors.termAndCondition && (
          <Typography color="error" variant="caption">
            {fieldErrors.termAndCondition}
          </Typography>
        )}
      </Grid>
      <div className="checckk">
        <CustomCheckboxLabel
          label={"This Product booking is confirm manually on request"}
          fontSize="15px"
          marginBottom="30px"
          value={formData.isBookingConfirmedManually}
          onChange={(e) =>
            handleChange("isBookingConfirmedManually", e.target.checked)
          }
        />
      </div>

      <Box>
        <Box sx={{ my: 5 }}>
          <h4 style={{ fontWeight: "700", fontSize: "20px" }}>Photos</h4>
        </Box>
        <UploadImagesComponent
          initialImages={experienceDetails?.photos || []}
          onChange={(value) => handleChange("photos", value)}
        />
        {fieldErrors.photos && (
          <Typography color="error" variant="caption">
            {fieldErrors.photos}
          </Typography>
        )}
      </Box>
      <Box>
        <Box my={1} mt={4}>
          <h4 style={{ fontWeight: "700", fontSize: "20px" }}>Videos</h4>
        </Box>
        <UploadVideosComponent
          initialVideos={experienceDetails?.videos || []}
          onChange={(value) => handleChange("videos", value)}
        />
        {fieldErrors.videos && (
          <Typography color="error" variant="caption">
            {fieldErrors.videos}
          </Typography>
        )}
      </Box>
      <Box mt={5} mx={"auto"} width={{ xs: "100%", md: "50%" }}>
        <CustomButton onClick={handleSubmit} disabled={loading}>
          {loading ? (
            <CircularProgress size={30} sx={{ color: "white" }} />
          ) : (
            type === "add" ? "Add Experience" : "Edit Experience"
          )}
        </CustomButton>
      </Box>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="change-date-title"
        PaperProps={{
          sx: {
            width: "400px",
            maxWidth: "90%",
            borderRadius: "12px",
          },
        }}
      >
        <DialogTitle
          id="change-date-title"
          sx={{
            fontSize: "24px",
            fontWeight: 700,
            color: theme.colors.text,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Select Date
          <IconButton
            onClick={handleClose}
            sx={{
              color: theme.colors.text,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div style={{ fontFamily: "Arial, sans-serif" }}>
            <style>
              {`
        .react-calendar {
          width: 100%;
          max-width: 375px;
          margin: 0 auto;
          box-sizing: border-box;
        }

        .react-calendar__navigation button {
          color: #121212;
        }

        .react-calendar__month-view__weekdays {
          font-size: 14px;
          font-weight: 400;
          color: #121212;
        }

        .react-calendar__month-view__weekdays abbr {
          text-decoration: none;
          border: none;
        }

        .react-calendar__tile {
          padding: 5px;
          font-size: 12px;
          text-align: center;
          width: 20px;
          height: 50px;
        }

        .react-calendar__tile--weekend {
          color: inherit;
        }

        .highlight {
          background-color: #f0f0f0;
          border-radius: 50%;
          width: 20px;
          height: 50px;
        }

        .react-calendar__tile--disabled {
          background-color: transparent !important;
          color: grey !important;
          pointer-events: none;
        }

        .react-calendar__tile--today {
          background-color: #FF7900 !important;
          color: white !important;
          border-radius: 50%;
          font-weight: bold;
        }

        .react-calendar__tile--selected-row {
          background-color: #FF7900 !important;
          color: white !important;
          border-radius: 50%;
          font-weight: bold;
        }

        .react-calendar__navigation button.react-calendar__navigation__label {
          pointer-events: none;
          color: #121212;
          background: none;
          border: none;
        }

        .react-calendar__navigation button.react-calendar__navigation__arrow {
          pointer-events: auto;
        }

        @media (max-width: 375px) {
          .react-calendar {
            max-width: 100%;
          }

          .react-calendar__tile {
            padding: 3px;
            font-size: 10px;
            width: 30px;
            height: 30px;
          }

          .react-calendar__tile--now,
          .react-calendar__tile--now.react-calendar__tile--active,
          .highlight {
            width: 30px;
            height: 30px;
          }

          .react-calendar__month-view__weekdays {
            font-size: 10px;
          }

          .react-calendar__navigation button {
            font-size: 12px;
          }
        }
      `}
            </style>

            <Calendar
              maxDate={new Date(today.getFullYear() - 5, 11, 31)}
              onChange={(date) => handleDateChange(new Date(date))}
              value={
                selectedDate
                  ? new Date(selectedDate)
                  : new Date(today.getFullYear() - 5, 11, 31)
              }
              view={calendarView}
              minDetail="year"
              onActiveStartDateChange={({ activeStartDate, view }) => {
                if (view === "decade") {
                  setCalendarView("year");
                } else if (view === "year") {
                  setTimeout(() => {
                    setSelectedDate(activeStartDate);
                    setCalendarView("month");
                  }, 100);
                }
              }}
              tileClassName={({ date, view }) => {
                const selected = new Date(selectedDate);
                if (
                  date.getFullYear() === selected.getFullYear() &&
                  date.getMonth() === selected.getMonth() &&
                  date.getDate() === selected.getDate()
                ) {
                  return "highlight";
                }
                return null;
              }}
              next2Label={null}
              prev2Label={null}
              navigationLabel={({ date, view }) =>
                view === "year"
                  ? `${date.getFullYear()}`
                  : `${date.toLocaleString("default", { month: "long" })} ${date.getFullYear()}`
              }
            />
          </div>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default ExperienceCreation;


